import { useCms } from '~/components/hooks/useCms';
import type { EmailGeneralConfigurationData } from '~/components/SystemConfiguration/EmailConfiguration/emailConfigurationTypes';
import useDataFetcher from '~/components/useDataFetcher';

interface UseEmailGeneralConfigurationReturn {
  isLoading: boolean;
  isError: boolean;
  generalConfiguration: EmailGeneralConfigurationData | undefined;
}

/**
 * Custom hook to fetch email general configuration for an organization
 * @returns Object containing loading state, error state, data, and computed flags
 */
export const useEmailGeneralConfiguration = (): UseEmailGeneralConfigurationReturn => {
  const { userOrganization } = useCms();

  const {
    isLoading,
    isError,
    data: generalConfiguration,
  } = useDataFetcher<EmailGeneralConfigurationData>(
    `/api/v1/email_configuration/organizations/${userOrganization.id}/general_configuration`
  );

  return {
    isLoading,
    isError,
    generalConfiguration,
  };
};
